/**
 * @file 路由路徑常數
 * @description 定義應用程式所有路由路徑的常數，供路由設定與頁面導航使用
 */

/** 路由路徑常數物件 */
const routerPath = {
  home: '/',
  posts: 'posts',
  postList: 'postList',
  postPage: 'postPage',
  timeline: 'timeline',
  categories: 'categories',
  categoryList: 'categoryList',
  categoryPostsPage: 'categoryPostsPage',
  about: 'about',
  // backstage: 'backstage'
  login: 'login',
  secretDoor: 'secretDoor',
  secretDoor_Post: 'post',
  secretDoor_Post_PostList: 'postList',
  secretDoor_Post_PostPage: 'postPage',
  secretDoor_Category: 'category',
  secretDoor_Category_CategoryList: 'categoryList'
} as const;

/** 路由路徑鍵值型別 */
export type RouterPathKey = keyof typeof routerPath;
/** 路由路徑值型別 */
export type RouterPathValue = (typeof routerPath)[RouterPathKey];

export default routerPath;
